import { Button, Modal } from 'antd';

export default function ConfirmLeaveModal(props: { open?: boolean; onConfirm?: () => void; onCancel?: () => void }) {
    return (
        <Modal
            open={props.open}
            zIndex={100000}
            onCancel={props.onCancel}
            onClose={props.onCancel}
            title="آیا اطمینان دارید از صفحه خارج میشوید؟"
            footer={
                <div className="gap-8 center-content-y justify-content-end">
                    <Button type="text" onClick={props.onCancel}>
                        خیر
                    </Button>
                    <Button onClick={props.onConfirm} danger type="text">
                        بله
                    </Button>
                </div>
            }
        >
            <p>شما تغییراتی در فرم فعلی انجام داده اید. آیا اطمینان دارید که میخواهید از صفحه خارج شوید؟</p>
        </Modal>
    );
}
